import { cn } from '@kit/ui/utils';

/**
 * The Calibrated Arc symbol: a ring with a single thin arc cut from its
 * upper-right quadrant, like a phase indicator on a scientific instrument.
 * Not a crescent. This is the brand's one mark of personality. Readable at
 * 16px (favicon) and at billboard scale because it is geometrically clean.
 *
 * Path: a 340deg arc on r=12 centred at (16,16), leaving a ~20deg gap centred
 * on the upper-right (the leading edge of the "phase"). currentColor so callers
 * set the tone (ink on the light canvas, per the selenos-brand tokens).
 */
export function ArcSymbol({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      role="presentation"
      aria-hidden="true"
      className={className}
    >
      <path
        d="M 22.88 6.17 A 12 12 0 1 0 25.83 9.12"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
    </svg>
  );
}

/**
 * Logo lockup: the Calibrated Arc symbol + the SELENOS wordmark in Geist,
 * weight 600, uppercase, tight tracking. The symbol carries the arc; the
 * wordmark stays clean and infrastructural.
 */
export function SelenosWordmark({
  className,
  symbolClassName,
}: {
  className?: string;
  symbolClassName?: string;
}) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <ArcSymbol
        className={cn(
          'h-[1.15em] w-[1.15em] text-[var(--sel-accent)]',
          symbolClassName,
        )}
      />
      <span className="font-semibold tracking-[0.16em] text-[var(--sel-ink)] uppercase">
        Selenos
      </span>
    </span>
  );
}
